import css from './header.module.css'
import { joinClassNames } from '../../utilities'
import React from 'react'

const ExtendedHeader = ({ className, children }) => {
  const classes = className
    ? joinClassNames(css.extended, className)
    : css.extended

  return (
    <div className={classes}>
      <section className="ds-l-container">
        <div className="ds-l-row">
          <div className="ds-l-col">{children}</div>
        </div>
      </section>
    </div>
  )
}

export default ExtendedHeader
